import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
    const { admin, login } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const nav = useNavigate();

    if (admin) return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await login(email, password);
            toast.success("Welcome back");
            nav("/admin");
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Login failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="relative z-10 min-h-screen flex items-center justify-center px-6" data-testid="admin-login-page">
            <form onSubmit={submit} className="w-full max-w-md">
                <div className="flex flex-col items-center mb-10">
                    <img
                        src="/brand/logo.png"
                        alt="Art N Moore"
                        className="w-40 h-40 object-contain mb-6"
                        data-testid="admin-login-logo"
                    />
                    <div className="label-caps text-[#8C3A3A] mb-3">Studio Admin</div>
                    <h1 className="font-serif-display text-5xl text-[#1A1A1A] font-light tracking-tighter">Sign in</h1>
                </div>

                <div className="space-y-8">
                    <div>
                        <label className="label-caps block mb-2">Email</label>
                        <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="underline-input" placeholder="you@email.com" data-testid="admin-email-input" />
                    </div>
                    <div>
                        <label className="label-caps block mb-2">Password</label>
                        <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="underline-input" placeholder="••••••••" data-testid="admin-password-input" />
                    </div>
                    <button type="submit" disabled={busy} className="w-full bg-[#1A1A1A] text-[#FAFAF7] px-10 py-4 rounded-full text-sm tracking-wide font-medium hover:bg-[#8C3A3A] hover:text-white disabled:opacity-50 transition-colors" data-testid="admin-login-submit">
                        {busy ? "Signing in..." : "Sign In"}
                    </button>
                </div>
            </form>
        </div>
    );
}
